import { useEffect, useContext, useState } from 'react'
import { toast } from 'react-toastify'

import { AparienciaContext } from '../../../../../context/aparienciaContext/AparienciaProvider'
import { typesCounter } from '../../../../../context/types/typesCounter'
import { UserCounterContext } from '../../../../../context/userCounter/UserCounterProvider'
import { useLazyRegistrationCheckQuery, useGetPlatformRolesQuery, useAssignRoleToUserMutation } from '../../../../../store/api/identia'
import ProgressNS from '../../../../general/progress/ProgressNS'
import SpinnerCertificate from '../../../../general/spinner/SpinnerCertificate'
// import Notification, { type } from '../../../../general/toast/Toast';
import FormAddUser from './items/FormAddUser'
import { AuthContext } from '../../../../../context/auth/AuthProvider'

interface PropsAdd {
    // createUser: (data: Data) => void
    setShowModalSearchStudent: React.Dispatch<React.SetStateAction<boolean>>
}

export interface IResponseGetRoles {
    message: string
    roles: Role[]
}

export interface Role {
    rol: string
    _id: string
}

const DEFAULT_USER_PHOTO = 'https://www.fisheries.noaa.gov/themes/custom/noaa_components/images/ProfilePic_Placeholder.jpg'

const SearchStudentCounter = ({ setShowModalSearchStudent }: PropsAdd) => {
    const { state: stateApariencia } = useContext(AparienciaContext)
    const { user: authState } = useContext(AuthContext)
    const [search, setSearch] = useState('')
    const [exists, setExists] = useState(1)
    const [user, setUser] = useState<any>('')
    const [loading, setloading] = useState(false)
    const [loader, setloader] = useState(false)
    const { dispatch } = useContext(UserCounterContext)
    const [roles, setRoles] = useState<Role[]>([])
    const [runRegistrationCheck] = useLazyRegistrationCheckQuery()
    const [assignRole] = useAssignRoleToUserMutation()
    const platformId = authState.platform?.id || 'multiedu'
    const { data: platformRoles } = useGetPlatformRolesQuery({ platformId })

    useEffect(() => {
        if (platformRoles) {
            const mappedRoles: Role[] = platformRoles.map((r) => ({
                _id: r.id,
                rol: r.name,
            }))
            setRoles(mappedRoles)
        }
    }, [platformRoles])

    const searchStudents = async () => {
        setloader(true)
        try {
            const data = await runRegistrationCheck({
                typeCredential: 'email',
                credential: search,
                platform: authState.platform?.id || authState.platform?.alias || 'multiedu',
                entity: stateApariencia.currentIdEntity,
            }).unwrap()

            const isRegisteredInOtherEntitySamePlatform =
                data.isRegistered && data.isRegisteredInPlatform && !data.hasAccessInEntity
            const isRegisteredOutsidePlatform =
                data.isRegistered && !data.isRegisteredInPlatform && !data.hasAccessInEntity

            if (!data.isRegistered) {
                setExists(2)
                setUser('')
            }

            if (
                (isRegisteredInOtherEntitySamePlatform || isRegisteredOutsidePlatform)
                && data.user
            ) {
                setExists(5)
                setUser({
                    _id: data.user.id,
                    name: data.user.attributes?.name || '',
                    lastname: data.user.attributes?.lastname || '',
                    email: data.user.attributes?.email || '',
                    photo: data.user.attributes?.photo || DEFAULT_USER_PHOTO,
                })
            }

            if (data.hasAccessInEntity && data.user) {
                setExists(4)
                setUser({
                    _id: data.user.id,
                    name: data.user.attributes?.name || '',
                    lastname: data.user.attributes?.lastname || '',
                    email: data.user.attributes?.email || '',
                    photo: data.user.attributes?.photo || DEFAULT_USER_PHOTO,
                })
            }
        } catch (err: any) {
            console.log(err)
        } finally {
            setloader(false)
        }
    }

    const handleAddUser = async (id: any) => {
        setloading(true)

        try {
            const estudianteRole = roles.find((r) =>
                r.rol.toLowerCase().includes('estudiante'),
            )

            if (!estudianteRole) {
                throw new Error('No se encontró el rol de estudiante en la plataforma')
            }

            await assignRole({
                userId: id,
                role_id: estudianteRole._id,
                context_type: 'entity',
                context_id: stateApariencia.currentIdEntity,
            }).unwrap()

            const datita = {
                id: id,
                name_student: user.name,
                lastname: user.lastname,
                email: user.email,
                photo: user.photo,
                phone: user.phone || '',
                address: user.address || '',
                dni: user.dni || '',
                schedule: '',
                course_of_interest: user.course_of_interest || '',
                username: user.email,
                password: '',
            }

            dispatch({
                type: typesCounter.createUserCounter,
                payload: datita,
            })

            toast.success('El usuario ha sido asignado correctamente')
            setShowModalSearchStudent(false)
        } catch (e: any) {
            console.error(e)
            toast.error(
                e.data?.message || 'Ha ocurrido un error al asignar el usuario',
            )
        } finally {
            setloading(false)
        }
    }

    const onKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            searchStudents()
        }
    }

    return (
        <div className="main_searchStudent">
            <div className="headSearchStudent">
                <i
                    className="fas fa-times"
                    onClick={() => setShowModalSearchStudent(false)}
                />
            </div>
            <div className="bodySearchStudent scroll">
                {exists === 3 ? (
                    <>
                        <div className="contentSearch">
                            <div className="back_button" onClick={() => setExists(2)}>
                                <i className="fas fa-long-arrow-alt-left"></i>
                                <span>Regresar</span>
                            </div>

                            <h2>Agregar Estudiante</h2>
                        </div>

                        <div className="containerBody">
                            <div className="content_add_user">
                                {/* <div className="text_container">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum ipsum, facilis rem corporis temporibus nulla veniam ducimus ullam quod non vitae nemo quibusdam voluptatum. Modi harum architecto saepe delectus at.</p>
                                </div> */}

                                <FormAddUser
                                    setShowModalSearchStudent={setShowModalSearchStudent}
                                    emailStudent={search}
                                    roles={roles}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="contentSearch">
                            <h2>Agregar Estudiante</h2>
                            <div className="search_container">
                                <input
                                    type="text"
                                    placeholder="Buscar"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyDown={onKeyDown}
                                />
                                <i className="fas fa-search" onClick={searchStudents}></i>
                            </div>
                            <button
                                type="button"
                                onClick={() => setExists(3)}
                            >
                                {' '}
                                <i className="fas fa-plus-circle"></i> Agregar
                                nuevo{' '}
                            </button>
                        </div>

                        <div className="containerBody">
                            {loader ? (
                                <div className="contentBody">
                                    <ProgressNS />
                                    {/* <div className="response_body">
                                                    <h5>  </h5>
                                            </div> */}
                                </div>
                            ) : exists === 2 ? (
                                <div className="contentBody">
                                    <div className="response_body">
                                        <h5>
                                            No se encontró usuario, ¿desea agregarlo
                                            manualmente?
                                        </h5>
                                        <button
                                            type="button"
                                            onClick={() => setExists(3)}
                                        >
                                            {' '}
                                            <i className="fas fa-plus-circle"></i> Agregar
                                            nuevo{' '}
                                        </button>
                                    </div>
                                </div>
                            ) : exists === 4 ? (
                                <div className="contentBody">
                                    <div className="response_body">
                                        <h5>
                                            {' '}
                                            Usuario {user.email} ya existe en la entidad{' '}
                                        </h5>
                                        {/* <button type="button" onClick={() => setExists(3)} > <i className="fas fa-plus-circle"></i>  </button> */}
                                    </div>
                                </div>
                            ) : exists === 5 ? (
                                <div className="info_user">
                                    <img
                                        src={user.photo}
                                        className="img_photo"
                                        alt="phot"
                                        onError={(e) => {
                                            e.currentTarget.src = DEFAULT_USER_PHOTO
                                        }}
                                    />
                                    <div className="data_info">
                                        <div className="data_info_name">
                                            <p> {user.name} {user.lastname} </p>
                                            <p> {user.email} </p>
                                        </div>
                                        <div className="assing_name">
                                            {loading ? (
                                                <SpinnerCertificate></SpinnerCertificate>
                                            ) : (
                                                <div
                                                    className="button_center"
                                                    onClick={() =>
                                                        handleAddUser(user._id)
                                                    }
                                                >
                                                    Agregar
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="contentBody">
                                    <div className="response_body">
                                        <h5>
                                            Busca el usuario ingresando su correo, para
                                            saber si ya esta registrado en la entidad
                                        </h5>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default SearchStudentCounter
